// The filtered user endpoints can briefly lag behind enable/disable mutations.
// This delay is longer than the measured 2–6 second propagation window.
export const FILTERED_USERS_REFRESH_DELAY_MS = 6500;

export const hasColumnFilters = (table) =>
  Boolean(table?.state?.query?.filters?.length);

export const createUsersRefreshScheduler = ({
  getTable,
  getInactiveListVisible,
  onDeferredRefreshStart = () => {},
  onWaitingChange = () => {},
  delay = FILTERED_USERS_REFRESH_DELAY_MS,
  setTimeoutFn = setTimeout,
  clearTimeoutFn = clearTimeout,
}) => {
  let timeoutId;
  let isWaiting = false;

  const setWaiting = (waiting) => {
    if (isWaiting !== waiting) {
      isWaiting = waiting;
      onWaitingChange(waiting);
    }
  };

  const cancel = () => {
    if (timeoutId !== undefined) {
      clearTimeoutFn(timeoutId);
      timeoutId = undefined;
    }
    setWaiting(false);
  };

  const complete = () => setWaiting(false);

  const refresh = () => {
    cancel();

    const table = getTable();
    if (!table) {
      return;
    }

    if (!hasColumnFilters(table)) {
      table.onQueryChange();
      return;
    }

    const inactiveListVisibleWhenScheduled = getInactiveListVisible();
    setWaiting(true);
    timeoutId = setTimeoutFn(() => {
      timeoutId = undefined;
      const currentTable = getTable();

      if (
        getInactiveListVisible() === inactiveListVisibleWhenScheduled &&
        hasColumnFilters(currentTable)
      ) {
        onDeferredRefreshStart();
        currentTable.onQueryChange();
      } else {
        complete();
      }
    }, delay);
  };

  return { cancel, complete, refresh };
};
